import React, { useContext, useEffect } from 'react'
import VideoJS from '../../components/player/videoJS'
import { isEmpty } from 'lodash'
import { getEcommTrailerUrl } from '../../utils/helper'
import { AppContext } from '../../context/app'

const ECommerceTrailerPlayer = ({ poster, preview, quality }) => {
  const playerRef = React.useRef(null)
  const { accountObj } = useContext(AppContext)

  useEffect(() => {
    if (!isEmpty(preview)) {
      changeSource(preview, poster)
    }
  }, [preview, poster])

  const videoJsOptions = {
    // lookup the options in the docs for more options
    // autoplay: true,
    controls: true,
    responsive: true,
    muted: true,
    loadingSpinner: true,
    autoplay: false,
    liveui: true,
    poster: poster,
    loop: true,
    controlBar: {
      pictureInPictureToggle: false,
      fullscreenToggle: false,
    },
    // preload: "metadata",
    // fluid: true,
    // aspectRatio: "16:9",
    // fill: true,
    suppressNotSupportedError: true,
    sources: [
      preview && {
        src: getEcommTrailerUrl(accountObj?.cf_domain_name, preview, quality),
        type: 'application/x-mpegURL',
      },
    ],
  }

  const handlePlayerReady = (player) => {
    playerRef.current = player

    // you can handle player events here
    player.on('waiting', () => {
      // console.log('player is waiting')
    })

    player.on('canplay', () => {
      // console.log('player is canplay')
    })

    player.on('dispose', () => {
      // console.log('player will dispose')
    })
  }

  const changeSource = (preview, poster) => {
    if (!playerRef.current) {
      return
    }

    playerRef.current.muted(true)
    playerRef.current.autoplay(true)
    playerRef.current.poster(poster)
    playerRef.current.src([
      preview && {
        src: getEcommTrailerUrl(accountObj?.cf_domain_name, preview, quality),
        type: 'application/x-mpegURL',
      },
    ])
  }

  return (
    <div className="relative h-full w-full bg-white rounded-[10px] overflow-hidden">
      <div className="h-full w-full">
        <VideoJS options={videoJsOptions} onReady={handlePlayerReady} cover={true} />
      </div>
    </div>
  )
}

export default ECommerceTrailerPlayer
